import { render, staticRenderFns } from "./uploadCase.vue?vue&type=template&id=b9638b12&scoped=true"
import script from "./uploadCase.vue?vue&type=script&lang=js"
export * from "./uploadCase.vue?vue&type=script&lang=js"
import style0 from "./uploadCase.vue?vue&type=style&index=0&id=b9638b12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9638b12",
  null
  
)

export default component.exports